export enum EUserPageLinks {
  PUBLIC = '/public',
  DOCUMENTS = '/public/documents',
  ACCESS_DENIED = '/public/access-denied',
  DOCUMENT_PREVIEW = '/public/document-preview',
  SEARCH_TERM = '/public/search-term',
  PRINT = '/print',
}
